import { envs } from '@/constants';
import { RequiredAny } from 'ui-kit/lib/types';

export const testId = (testId: string | undefined) => envs.DISPLAY_DATA_TEST_ID ? testId : undefined;
export const INHERITED_DATA_TEST_ID = undefined;
export const inheritDataTestId = (props: RequiredAny, relativeId?: string) => props['data-test-id'] ? relativeId ? props['data-test-id'] + '_' + relativeId : props['data-test-id'] : undefined;
